import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import { AnalyticsService } from './analytics.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  constructor(private analyticsService: AnalyticsService, private http: HttpClient, private store: Store) { }

  // async subscribeJob(mobile: string, alert: any) {
  //   const utm = this.store.selectSnapshot(UtmState.utm);
  //   const user = this.store.selectSnapshot(AuthState.user);
  //   const utmQuery = Utility.getUtmQueryUrl(utm);

  //   this.analyticsService.gtmEvent('subscribe-search', 'seeker', alert.SubscribeSource);

  //   delete alert.SearchParams._urlParams; //to prevent error sending the object
  //   var res = await this.http.post(environment.app.apiUrl + `subscription/subscribe/${mobile}?${utmQuery}`, alert).toPromise();
  //   await this.store.dispatch(Current).toPromise();
  //   return res;
  // }

  verify(token: string) {
    this.analyticsService.gtmEvent('verify-subscribe', 'seeker');
    return this.http.get<any>(environment.app.apiUrl + 'subscription/verify/' + token).toPromise();
  }
  remove(token: string) {
    return this.http.post(environment.app.apiUrl + 'subscription/remove/' + token, {}).toPromise();
  }
  save(criteria: any) {
    return this.http.post(environment.app.apiUrl + 'subscription/save/', criteria).toPromise();
  }

  verifyForUser(token: string): any {
    this.analyticsService.gtmEvent('verify-subscribe', 'seeker');
    return this.http.get<any>(environment.app.apiUrl + 'subscription/verify/user/' + token).toPromise();
  }
  saveForUser(criteria: any): any {
    return this.http.post(environment.app.apiUrl + 'subscription/save/user', criteria).toPromise();
  }
  adminSaveForUser(criteria: any, userId: string): any {
    return this.http.post(environment.app.apiUrl + `subscription/save/admin/${userId}`, criteria).toPromise();
  }
  removeForUser(token: string) {
    return this.http.post(environment.app.apiUrl + 'subscription/remove/user/' + token, {}).toPromise();
  }
  adminVerifyForUser(token: string, userId: string): any {
    return this.http.get<any>(environment.app.apiUrl + `subscription/verify/admin/${userId}/${token}`).toPromise();
  }
  adminRemoveForUser(token: string, userId: string) {
    return this.http.post(environment.app.apiUrl + `subscription/remove/admin/${userId}/${token}`, {}).toPromise();
  }
}
